import type React from 'react';

import * as st from './Info.module.scss';

type Props = {
	data: any;
	children?: React.ReactNode;
};

const Info: React.FC<Props> = ({ data, children }) => {
	return (
		<div className={st.info}>
			{/* <div className={st.icon}>{children}</div> */}
			<span>{data}</span>
		</div>
	);
};

export default Info;
